import React, { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { canAccessAdminPanel } from '../services/permissionService';

interface AdminProtectedRouteProps {
  children: ReactNode;
}

/**
 * مكون لحماية مسارات لوحة التحكم
 * يتحقق من أن المستخدم مسجل الدخول وليس عميلًا في المتجر
 */
const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log('AdminProtectedRoute: currentUser =', currentUser);
    console.log('AdminProtectedRoute: location =', location);
  }, [currentUser, location]);

  // التحقق من تسجيل الدخول
  if (!currentUser) {
    console.log('AdminProtectedRoute: Redirecting to login - User not logged in');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // التحقق من صلاحية الوصول إلى لوحة التحكم
  if (!canAccessAdminPanel(currentUser)) {
    console.log('AdminProtectedRoute: Redirecting to store - User does not have admin access');

    // عرض رسالة تنبيه للمستخدم في وحدة التحكم
    console.error('ليس لديك صلاحية الوصول إلى لوحة التحكم');

    return <Navigate to="/" replace />;
  }

  console.log('AdminProtectedRoute: Rendering admin content');
  return <>{children}</>;
};

export default AdminProtectedRoute;
